import { render, staticRenderFns } from "./createManager.vue?vue&type=template&id=19cab4cb&"
import script from "./createManager.vue?vue&type=script&lang=js&"
export * from "./createManager.vue?vue&type=script&lang=js&"
import style0 from "./createManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports